/* eslint-disable react/prop-types */
// Apple Sign-in button — POSTs /auth/apple/start, follows Apple's authorize
// URL, lets Apple handle the rest. The backend callback sets the
// session_token cookie and bounces the browser to /apple-return, where the
// SPA bridge page (AppleReturn.jsx) finalises the flow.
import { useState } from "react";
import axios from "axios";
import { setLastAuthMethod } from "@/lib/lastAuthMethod";

function AppleLogo() {
    return (
        <svg width="16" height="16" viewBox="0 0 384 512" aria-hidden="true">
            <path
                fill="currentColor"
                d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
            />
        </svg>
    );
}

export default function AppleSignInButton({
    persona = "",
    emailOptIn = false,
    next = "/dashboard",
    className = "",
}) {
    const [loading, setLoading] = useState(false);

    const start = async () => {
        setLoading(true);
        try {
            // Stash `next` in sessionStorage so the bridge page can pick it up
            // after Apple bounces the user back to /apple-return.
            try {
                sessionStorage.setItem("bl_apple_next", next || "/dashboard");
            } catch {
                /* ignore — sessionStorage disabled */
            }
            const baseURL = process.env.REACT_APP_BACKEND_URL;
            const resp = await axios.post(
                `${baseURL}/api/auth/apple/start`,
                { persona: persona || undefined, email_opt_in: !!emailOptIn },
                { withCredentials: true },
            );
            const url = resp?.data?.url;
            if (url) {
                setLastAuthMethod("apple");
                window.location.href = url;
            } else {
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            // Surface a soft error; existing toast machinery is in the parent.
            const detail =
                e?.response?.data?.detail || "Apple sign-in unavailable right now.";
            // eslint-disable-next-line no-alert
            alert(detail);
        }
    };

    return (
        <button
            onClick={start}
            disabled={loading}
            type="button"
            data-testid="apple-signin-btn"
            className={
                "w-full flex items-center justify-center gap-3 px-5 py-3.5 rounded-full "
                + "bg-black text-white hover:bg-bl-charcoal transition-colors font-medium "
                + "disabled:opacity-60 "
                + className
            }
        >
            <AppleLogo />
            {loading ? "Redirecting…" : "Continue with Apple"}
        </button>
    );
}
